// Install a one-time guard to prevent duplicate registration of Google Maps
// "already defined" warnings when the Maps API or Places library is
if (
  typeof window !== "undefined" &&
  window.customElements &&
  !window.__gmpDefineGuardInstalled
) {
  const originalDefine = window.customElements.define.bind(
    window.customElements
  );
  window.customElements.define = (name, ctor, options) => {
    if (name && name.startsWith("gmp-") && window.customElements.get(name)) {
      return; // silently ignore duplicate definitions
    }
    try {
      return originalDefine(name, ctor, options);
    } catch {
      return; // swallow duplicate define errors safely
    }
  };
  window.__gmpDefineGuardInstalled = true;
}
